import { render, staticRenderFns } from "./mFooter.vue?vue&type=template&id=3861be53&scoped=true"
import script from "./mFooter.vue?vue&type=script&lang=js"
export * from "./mFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_064421c868bf9d44c080cdd6f5d40e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3861be53",
  null
  
)

export default component.exports